export const BRAND_NAME = typeof ENV !== 'undefined' ? ENV.BRAND_NAME : process.env.BRAND_NAME || 'FuelPortfolio';

// Sessions
export const SESSION_EXPIRATION_TIME = 1000 * 60 * 60 * 24 * 30;

// Socials
export const socialProviders = ["google"] as const;
export const providers = ["local", ...socialProviders] as const;

// Data
export const ROWS_PER_PAGE_OPTIONS = [10, 15, 20, 25, 50];
export const MORE_ROWS_PER_PAGE_OPTIONS = [25, 50, 75, 100, 250];
export const LESS_ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 20, 25];

// Enums
export const availableProductUnits = ["liters", "gallons"] as const;
export type ProductUnitType = (typeof availableProductUnits)[number];

export const availableCurrencies = ["mxn", "usd"] as const;
export type CurrencyType = (typeof availableCurrencies)[number];

export const availableOrderTypes = ["purchase", "sale"] as const;
export type OrderType = (typeof availableOrderTypes)[number];

export const availableExternalTerminalTypes = [
  "origin",
  "destination",
] as const;
export type ExternalTerminalType =
  (typeof availableExternalTerminalTypes)[number];

export const availablePurchaseOrderItemStatuses = [
  "pre",
  "ongoing",
  "completed",
  "canceled",
] as const;
export type OrderItemStatus =
  (typeof availablePurchaseOrderItemStatuses)[number];

export const availableDeliveryStatuses = [
  "pre",
  "ongoing",
  "returning",
  "completed",
] as const;
export type DeliveryStatus = (typeof availableDeliveryStatuses)[number];

export const availableOrderItemNotesType = [
  "flow-notes",
  "delivery-notes",
] as const;
export type OrderItemNotesType = (typeof availableOrderItemNotesType)[number];

export const availableFromTankerTypes = ["pipa", "fractank"] as const;
export type FromTankerType = (typeof availableFromTankerTypes)[number];

export const availableToTankerTypes = ["pipa", "fractank"] as const;
export type ToTankerType = (typeof availableToTankerTypes)[number];

export const availableFlowTypes = ["inflow", "outflow"] as const;
export type FlowType = (typeof availableFlowTypes)[number];

export const unitToLabel = {
  gallons: "Galones",
  liters: "Litros",
} satisfies Record<ProductUnitType, string>;

export const DEFAULT_PRODUCT_UNIT = "liters";
export const DEFAULT_CURRENCY = "mxn";
export const DEFAULT_ORDER_ITEM_STATUS = "pre";

// Image uploads
export const MAX_IMAGE_SIZE = 1024 * 1024 * 3; // 3MB

// Price & cost details
export const DEFAULT_PRICE_COMPONENT_CONCEPT = "Molecula";
export const DEFAULT_COST_COMPONENT_CONCEPT = "Precio promedio";

export const orderTypeToName = {
  purchase: "compra",
  sale: "venta",
};

export const orderTypeToLoadName = {
  purchase: "descarga",
  sale: "carga",
};

export const orderTypeToFlowName = {
  purchase: "entrada",
  sale: "salida",
};

export const PUBLIC_ROUTES = [
  "/",
  "/login",
  "/logout",
  "/signup",
  "/forgot-password",
  "/onboarding",
  "/onboarding/google",
  "/team-onboarding",
  "/reset-password",
  "/verify",
  "/team",
];

export const availableTeamImageTypes = ["logo", "logo-and-name"] as const;
export type TeamImageType = (typeof availableTeamImageTypes)[number];

export const DEFAULT_ROWS_PER_PAGE = MORE_ROWS_PER_PAGE_OPTIONS[0];

// Filters
export const FILTER_PARAM_SEARCH = "search";
export const FILTER_PARAM_STATUS = "status";
export const FILTER_PARAM_PRODUCT = "product";
export const FILTER_PARAM_PROVIDER = "provider";
export const FILTER_PARAM_CLIENT = "client";
export const FILTER_PARAM_DATE_FROM = "date_from";
export const FILTER_PARAM_DATE_TO = "date_to";
export const FILTER_PARAM_DASHBOARD_FROM = "from";
export const FILTER_PARAM_DASHBOARD_TO = "to";

export const filterParamKeys = [
  FILTER_PARAM_SEARCH,
  FILTER_PARAM_STATUS,
  FILTER_PARAM_PRODUCT,
  FILTER_PARAM_PROVIDER,
  FILTER_PARAM_CLIENT,
  FILTER_PARAM_DATE_FROM,
  FILTER_PARAM_DATE_TO,
  FILTER_PARAM_DASHBOARD_FROM,
  FILTER_PARAM_DASHBOARD_TO,
] as const;

export type FilterKey = (typeof filterParamKeys)[number];
